import { useNautilusSelector } from "../../state/index.ts";
import { contentNodeOrNullSelector, getContentNodeSelector } from "./useGetContentNode.ts";

export const useContentNode = (nodeId: number) => {
  return useNautilusSelector((state) => contentNodeOrNullSelector(state, { nodeId }));
};

export const useGetContentNode = () => {
  return useNautilusSelector((state) => getContentNodeSelector(state));
};
